import React, { useState, useEffect, FC } from "react";
import Sketch from "react-p5";
import p5Types from "p5";

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return width;
}

export const Wave: FC = () => {
  const width = useWindowWidth();
  let yoff = 0.0;

  const setup = (p5: p5Types, canvasParentRef: Element) => {
    p5.createCanvas(width, 200).parent(canvasParentRef);
  };

  const draw = (p5: p5Types) => {
    p5.background(255);
    p5.fill(242, 242, 242);
    p5.beginShape();
    p5.stroke(242, 242, 242);

    let xoff = 0;
    for (let x = 0; x <= width; x += 2) {
      let y = p5.map(p5.noise(xoff, yoff), 0, 0.4, 200, 100);
      p5.vertex(x, y);
      xoff += 0.05;
    }
    yoff += 0.002;
    p5.vertex(p5.width, p5.height);
    p5.vertex(0, p5.height);
    p5.endShape(p5.CLOSE);
  };

  return (
    <Sketch
      key={width}
      style={{
        zIndex: -1,
        width: "100%",
        overflow: "hidden",
        backgroundColor: "#f2f2f2",
      }}
      setup={setup}
      draw={draw}
    />
  );
};
